import { toastShow } from '../ToastService';
import { sendEmail, sendEmailComunicado } from "./EmailRequest";



export const EnviarCorreo = async ({setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null} ) => {
    setLoadingCorreo(true);
    const objeto = {
        // to: "alberto_medina95@outlook.es",
        // cc: 'lmedina@ppf.com.hn',
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmail(objeto);
    if (result) {
        if(showToas){
            toastShow(toast, 'success', 'Correo enviado.');
        }
        setLoadingCorreo(false);
    } else {
        if(showToas){
        toastShow(toast, 'error', 'Correo no enviado.');
        }
        setLoadingCorreo(false);
    }
}

export const EnviarCorreoComunicado = async (setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null) => {
    setLoadingCorreo(true);
    console.log({attachments})
    const objeto = {
        // to: "alberto_medina95@outlook.es",
        // cc: 'lmedina@ppf.com.hn',
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmailComunicado(objeto);
    if (result) {
        if(showToas){
            toastShow(toast, 'success', 'Correo enviado.');
        }
        setLoadingCorreo(false);
    } else {
        if(showToas){
        toastShow(toast, 'error', 'Correo no enviado.');
        }
        setLoadingCorreo(false);
    }
}